export class ToggleSearch {
  constructor(searchClass, inputClass, toggleClass) {
    this.search = document.getElementsByClassName(searchClass)[0];
    this.input = document.getElementsByClassName(inputClass)[0];
    this.toggleClass = toggleClass;

    if(this.search && this.input) {
      this.events();
    }
  }

  mouseenter() {
    document.body.classList.add(this.toggleClass);
  }

  mouseleave() {
    if('' === this.input.value) {
      document.body.classList.remove(this.toggleClass);
    }
  }

  events() {
    this.search.addEventListener("touchstart", this.mouseenter.bind(this));
    this.search.addEventListener("touchleave", this.mouseleave.bind(this));
    this.search.addEventListener("mouseenter", this.mouseenter.bind(this));
    this.search.addEventListener("mouseleave", this.mouseleave.bind(this));
  }
}
